import { createRouter, createWebHistory } from 'vue-router';

import routes from './routes';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash };
    }

    return to.name === from.name ? savedPosition || { left: 0, top: 0 } : { left: 0, top: 0 };
  },
});

router.beforeEach(routeTo => {
  const title = routeTo.meta.title;
  if (typeof title === 'string') {
    document.title = title;
  }
});

export default router;
